import React from 'react'
import { Link } from 'react-router-dom'
import esquizofrenia from '../assets/images/psicologo/ansiedad.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${esquizofrenia})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Esquizofrenía</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Esquizofrenía</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
  <div className="container" style={{textAlign:'justify', padding:20}}>
    <div className="row justify-content-center">
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          La esquizofrenia es un trastorno mental grave que afecta la forma en que una persona piensa, siente y se comporta. Puede incluir alucinaciones, delirios y alteraciones del pensamiento, impactando de manera significativa la vida diaria.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es la esquizofrenia?</h4>
        <p className="text-muted">
          Se asocia con alteraciones en la conectividad de redes cerebrales y desequilibrios en neurotransmisores como la dopamina y el glutamato. La neuromodulación se utiliza como tratamiento complementario para mejorar síntomas resistentes a la medicación.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: movimientos repetitivos o anormales, problemas de sueño.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: pensamientos desorganizados, dificultad para concentrarse, alteraciones de la memoria.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: aislamiento social, descuido del autocuidado, reacciones emocionales inapropiadas.
        </p>
        <br />
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): estimulación en áreas temporales para reducir alucinaciones auditivas.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): modulación para mejorar funciones cognitivas.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para favorecer la organización del pensamiento y la estabilidad emocional.
        </p>
      </div>
    </div>
  </div>
</section>    <Footer/>
    </>
  )
}
